import { css } from '@linaria/core';

const headerRow = css`
  contain: strict;
  contain: size layout style paint;
  display: grid;
  grid-template-columns: var(--template-columns);
  grid-template-rows: var(--header-row-height);
  height: var(--header-row-height); // needed on Firefox
  line-height: var(--header-row-height);
  width: var(--row-width);
  position: sticky;
  top: 0;
  background-color: var(--header-background-color);
  font-weight: bold;
  z-index: 3;
  touch-action: none;
  text-align: right;
`;

export const headerRowClassname = `rdg-header-row ${headerRow}`;

const rowReorderTarget = css`
  cursor: grabbing !important;
  border-bottom: 2px solid var(--selection-color);
`;
export const rowReorderTargetClassname = `rdg-row-reorder-target ${rowReorderTarget}`;
